// 028C-2 — Curva de Crecimiento Niña de 5 a 9 años (corrección de
// numeración, ver PLAN.md Serie 028 — antes "028A3", código incorrecto).
import { crearFormularioCurvaCrecimiento } from './curvaCrecimiento';

export const Formulario028C2 = crearFormularioCurvaCrecimiento({ claveI18n: 'f028c2', curvasPdf: 'oms5a19' });
